module.exports = __webpack_public_path__ + "img/visa.936bc9e3.svg";